"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageVariantClass = exports.getImageContainerVariantClass = exports.getFooterVariantClass = exports.getContentVariantClass = exports.getHeaderVariantClass = void 0;
var getHeaderVariantClass = function (orientation, size, headerVariation) {
    var classes = [];
    if (orientation === 'column') {
        classes.push('squid-w-full');
        if (size === 'sm') {
            classes.push('squid-p-component-card-padding-tight');
        }
        else {
            classes.push('squid-pt-component-card-padding-base');
            classes.push('squid-pr-component-card-padding-base');
            classes.push('squid-pb-component-card-padding-tight');
            classes.push('squid-pl-component-card-padding-base');
        }
        if (headerVariation === 'border') {
            classes.push('squid-border-alias-color-border-base');
            classes.push('squid-border-b-component-card-border-width');
        }
    }
    return classes.length === 0 ? null : classes.join(' ');
};
exports.getHeaderVariantClass = getHeaderVariantClass;
var getContentVariantClass = function (orientation, size) {
    var classes = [];
    classes.push('squid-w-full');
    classes.push(size === 'lg'
        ? 'squid-p-component-card-padding-base'
        : 'squid-p-component-card-padding-tight');
    return classes.length === 0 ? null : classes.join(' ');
};
exports.getContentVariantClass = getContentVariantClass;
var getFooterVariantClass = function (orientation, size, footerVariation) {
    var classes = [];
    if (orientation === 'column') {
        classes.push('squid-w-full');
        classes.push('squid-mt-auto');
        if (size === 'sm') {
            classes.push('squid-p-component-card-padding-tight');
        }
        else {
            classes.push('squid-pt-component-card-padding-tight');
            classes.push('squid-pr-component-card-padding-base');
            classes.push('squid-pb-component-card-padding-tight');
            classes.push('squid-pl-component-card-padding-base');
        }
        if (footerVariation === 'border') {
            classes.push('squid-border-alias-color-border-base');
            classes.push('squid-border-t-component-card-border-width');
        }
    }
    return classes.length === 0 ? null : classes.join(' ');
};
exports.getFooterVariantClass = getFooterVariantClass;
var getImageContainerVariantClass = function (orientation, size, headerVariation) {
    var classes = [];
    if (orientation === 'column') {
        classes.push('squid-w-full');
        if (headerVariation !== 'image-bg') {
            if (size === 'sm') {
                classes.push('squid-pt-component-card-padding-base');
                classes.push('squid-pr-component-card-padding-base');
                classes.push('squid-pb-component-card-padding-tight');
                classes.push('squid-pl-component-card-padding-base');
            }
            else {
                classes.push('squid-pt-component-card-padding-base');
                classes.push('squid-pr-component-card-padding-tight');
                classes.push('squid-pb-component-card-padding-none');
                classes.push('squid-pl-component-card-padding-base');
            }
        }
    }
    return classes.length === 0 ? null : classes.join(' ');
};
exports.getImageContainerVariantClass = getImageContainerVariantClass;
var getImageVariantClass = function (orientation, headerVariation) {
    var classes = [
        'squid-w-full',
        'squid-h-full',
        'squid-object-cover',
    ];
    switch (headerVariation) {
        case 'image':
            classes.push('squid-rounded-component-card-border-radius-base');
            break;
        case 'image-bg':
            if (orientation === 'column') {
                classes.push('squid-rounded-tl-component-card-border-radius-base');
                classes.push('squid-rounded-tr-component-card-border-radius-base');
            }
            else {
                classes.push('');
                classes.push('squid-rounded-tl-component-card-border-radius-base');
                classes.push('squid-rounded-bl-component-card-border-radius-base');
                classes.push('squid-h-full');
            }
            break;
    }
    return classes.length === 0 ? null : classes.join(' ');
};
exports.getImageVariantClass = getImageVariantClass;
